import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=2307d1b6&scoped=true"
import script from "./guest.vue?vue&type=script&lang=js"
export * from "./guest.vue?vue&type=script&lang=js"
import style0 from "./guest.vue?vue&type=style&index=0&id=2307d1b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307d1b6",
  null
  
)

export default component.exports